import { useMutation } from '@/core/hooks/use-mutation'
import { addToast } from '@heroui/react'
import { zodResolver } from '@hookform/resolvers/zod'
import { useTranslations } from 'next-intl'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { verifyAccount } from '../../providers/client'
import { useEmailAuthStore } from '../../store/email-auth'
import { verifyAccountSchema } from '../../types/dtos/verify-code.dto'

export const useVerifyAccount = ({
  onSuccess,
  onClose,
}: {
  onSuccess: () => void
  onClose: () => void
}) => {
  const t = useTranslations()
  const { email, reset } = useEmailAuthStore()
  const form = useForm({
    defaultValues: {
      email,
      otp_code: '',
    },
    resolver: zodResolver(verifyAccountSchema),
  })

  const { isPending, mutate } = useMutation({
    mutation: verifyAccount,
    onSuccess() {
      reset()
      onSuccess()
      addToast({
        title: t('verifyAccount.success'),
        color: 'success',
      })
    },
    onError(error) {
      form.setError('otp_code', { message: error })
    },
  })

  useEffect(() => {
    if (!email) onClose()
  }, [email, onClose])

  const handleSubmit = form.handleSubmit(mutate)

  return { form, handleSubmit, isPending }
}
